<script lang="ts">
	import contact from '$lib/assets/images/contact.svg';
	import personCircleOutline from '$lib/assets/images/icons/person-circle-outline.svg';
	import puzzleOutline from '$lib/assets/images/icons/puzzle-outline.svg';
	import cashOutline from '$lib/assets/images/icons/cash-outline.svg';
	import documentsOutline from '$lib/assets/images/icons/documents-outline.svg';
	import ContactForm from '$lib/components/Global/ContactForm.svelte';
	import __ from '$lib/stores/TranslationStore';
</script>

<div class="bg-white">
	<div class="container mx-auto py-12">
		<div
			class="items-top flex h-full flex-col justify-center gap-12 overflow-hidden 2xl:container md:flex-row"
		>
			<div class="lg:w-1/2">
				<div>
					<h3 class="mt-4 text-4xl text-dark lg:text-5xl lg:leading-54">
						{$__('Seguro no minuto')}
					</h3>
					<h4 class="mt-7 text-lg text-dark">
						{$__('Preencha o nosso formulário de contacto e o seu agente Poupança no Minuto irá:')}
					</h4>
					<div class="mt-8">
						<div class="flex items-center gap-3 border-b border-light py-4 text-dark">
							<img src={personCircleOutline} alt="" />
							{$__('Conhecer o seu perfil')}
						</div>
						<div class="flex items-center gap-3 border-b border-light py-4 text-dark">
							<img src={puzzleOutline} alt="" />
							{$__('Desenhar um seguro com as coberturas certas para si')}
						</div>
						<div class="flex items-center gap-3 border-b border-light py-4 text-dark">
							<img src={cashOutline} alt="" />
							{$__('Negociar os melhores preços')}
						</div>
						<div class="flex items-center gap-3 border-b border-light py-4 text-dark">
							<img src={documentsOutline} alt="" />
							{$__('Tratar de tudo por si')}
						</div>
					</div>
					<img class="mt-12" src={contact} alt="contacto" />
				</div>
			</div>
			<div class="relative lg:w-1/2">
				<ContactForm
					referral="insurance_page"
					successText="Entraremos um contacto assim que possível para encontrar o seu seguro!"
					gaEvent="Form Insurance"
				/>
			</div>
		</div>
	</div>
</div>
